( (function( ) {

  function Helpers() {}

  window.Helpers = Helpers;

  }))();

(function (Helpers) {

	var helpers = new Helpers();
	window.helpers = helpers;

})(Helpers);